import { createFileRoute, redirect } from '@tanstack/react-router'
import { createProductionDashboardSearch } from 'routes/production-dashboard/-searchParams'
import { Route as NewRoute } from 'routes/production-dashboard/index'

export const Route = createFileRoute(
  '/production-dashboard/(deprecated_routes)/$orgID/$siteID/'
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        ...createProductionDashboardSearch({
          orgId: params.orgID,
          siteId: params.siteID,
        }),
      }),
      replace: true,
    })
  },
})
